import api from './api'
import type { DashboardMetrics } from '@/types'
import type { ApiResponse } from '@/types/api'

const AnalyticsService = {
  async getDashboardMetrics(
    period: 'today' | 'yesterday' | 'week' | 'month' = 'today',
  ): Promise<DashboardMetrics> {
    const response = await api.get<ApiResponse<DashboardMetrics>>('/api/v1/analytics/dashboard', {
      params: { period },
    })
    return response.data.data
  },

  async getMessageVolume(
    period: string,
    instanceId?: string,
  ): Promise<Array<{ hour: string; count: number }>> {
    const response = await api.get('/api/v1/analytics/messages/volume', {
      params: { period, instance_id: instanceId },
    })
    return response.data
  },

  async getResponseTimes(period: string): Promise<{
    average: number
    median: number
    p95: number
  }> {
    const response = await api.get('/api/v1/analytics/response-times', {
      params: { period },
    })
    return response.data
  },
}

export default AnalyticsService
